import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {settingOtodisApiService} from "../../services/otodis/SettingOtodisApiService";
import {Tooltip, Button, Col, Modal, Row, Table, DatePicker, Form, message} from 'antd';
import {CloudSyncOutlined, CopyOutlined} from "@ant-design/icons";
import {ListTransferStockStates} from "./types/ListTransferStockTypes";
import moment from "moment";

export interface ListTransferStockProps {

}

class ListTransferStock extends Component<ListTransferStockProps & any, ListTransferStockStates> {

    private readonly initState!: ListTransferStockStates;
    private tableColumn: any = [
        {
            title: 'Kode Transfer Stock',
            dataIndex: 'stock_transfer_code',
            width: 220,
            render: ((value: string, row: []) => {
                return (
                    <React.Fragment>
                        <span className={`font-90-link`} onClick={event => this.showDetail(row)}>{value}</span>
                        &nbsp; &nbsp;
                        <Tooltip title="Click untuk copy kode stock unit" color={'cyan'}>
                            <CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/>
                        </Tooltip>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Tanggal Pindah Stock',
            dataIndex: 'create_date',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Gudang Sumber',
            dataIndex: 'warehouse_name_source',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Gudang Tujuan',
            dataIndex: 'warehouse_name_destination',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Jumlah Stock',
            dataIndex: 'stock_count',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
    ]

    private tableDetail: any = [
        {
            title: 'Kode Stock Unit',
            dataIndex: 'stock_unit_code',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Kode Variant',
            dataIndex: 'vehicle_variant_code',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Nama Variant',
            dataIndex: 'vehicle_variant_name',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Kode Warna',
            dataIndex: 'vehicle_color_code',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Nomor Mesin',
            dataIndex: 'vehicle_engine_number',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Nomor Rangka',
            dataIndex: 'vehicle_chassis_number',
            width: 100,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
    ]

    constructor(props: ListTransferStockProps & any | any) {
        super(props);

        this.initState = {
            processing: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            processingFetchDetailTableData: true,
            processingFetchTableData: true,
            dataStock: [],
            pageSize: 100,
            showModalDetailStock: false,
            dataDetailStock: [],
            filterStartDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
            filterEndDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
        }
        this.state = {...this.initState}
    }

    closeModalDetailStock = (data: any) => {
        this.setState({
            showModalDetailStock: false,
        });
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
    }

    showDetail = async (data: any) => {
        await this.promisedSetState({
            dataDetailStock: [],
            processingFetchDetailTableData: true,
            processingFetchTableData: true,
        })

        settingOtodisApiService.getStockTransferWarehouse({
            dealerCode: this.state.dealerCode,
            transferCode: data.stock_transfer_code,
            dataType: "TRANSFER_STOCK_DETAIL",
        }).then(async value => {
            await this.promisedSetState({
                dataDetailStock: value.data.data,
                processingFetchDetailTableData: false,
                processingFetchTableData: false,
                showModalDetailStock: true,
            });
        }).catch(async reason => {
            await this.promisedSetState({
                dataDetailStock: [],
                processingFetchDetailTableData: false,
                processingFetchTableData: false,
                showModalDetailStock: true,
            })
        })
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });

        await this.fetchStockData();
    }

    fetchStockData = async () => {
        await this.promisedSetState({
            dataStock: [],
            processingFetchTableData: true,
        });

        settingOtodisApiService.getStockTransferWarehouse({
            dealerCode: this.state.dealerCode,
            dataType: "TRANSFER_STOCK",
            startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        }).then(async value => {
            await this.promisedSetState({
                dataStock: value.data.data,
                processingFetchTableData: false,
            });
        }).catch(async reason => {
            await this.promisedSetState({
                dataStock: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        console.log(pagination);
        console.log(filters);
        console.log(sorter);
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    onWarehouseStartDate = (data: any) => {
        this.setState({
            filterStartDate: data,
        });
    }

    onWarehouseEndDate = (data: any) => {
        this.setState({
            filterEndDate: data,
        });
    }

    async componentDidMount() {
        await this.fetchStockData();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Stock`} breadcrumbMenu={`List Perpindahan Gudang`} defaultSelectedKeys={['m-list-stock-transfer']} defaultOpenKeys={['sm-stock', 'sm-sm-stock-warehouse']}>
                    <div style={{padding: 24}}>
                        <Form layout={`inline`}>
                            <Form.Item label="Tanggal Mulai" className={'padTop-10'}>
                                <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onWarehouseStartDate(event)} format={'YYYY-MM-DD'}/>
                            </Form.Item>
                            <Form.Item label="Tanggal Akhir" className={'padTop-10'}>
                                <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onWarehouseEndDate(event)} format={'YYYY-MM-DD'}/>
                            </Form.Item>
                            <Form.Item className={'padTop-10'}>
                                <Button onClick={this.fetchStockData} type="primary" icon={<CloudSyncOutlined/>}> Go </Button>
                            </Form.Item>
                        </Form>
                    </div>
                    <br/>
                    <Table
                        rowKey={'stock_transfer_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataStock}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />

                    <Modal
                        visible={this.state.showModalDetailStock}
                        title="Detail Stock"
                        width={'80%'}
                        onOk={this.closeModalDetailStock}
                        onCancel={this.closeModalDetailStock}
                        cancelText={'Tutup'} okText={false}
                        footer={[
                            <Button key="back" type="primary" onClick={this.closeModalDetailStock}>
                                Tutup
                            </Button>,
                        ]}
                    >
                        <Row>
                            <Col span={8} className={`col-grey`}>Kode Transfer Stock:</Col>
                            <Col span={16}>{this.state.dataDetailStock?.[0]?.stock_transfer_code}</Col>
                            <Col span={8} className={`col-grey`}>Tanggal Pindah Stock:</Col>
                            <Col span={16}>{this.state.dataDetailStock?.[0]?.create_date}</Col>
                            <Col span={8} className={`col-grey`}>Gudang Sumber:</Col>
                            <Col span={16}>{this.state.dataDetailStock?.[0]?.warehouse_name_source}</Col>
                            <Col span={8} className={`col-grey`}>Gudang Tujuan:</Col>
                            <Col span={16}>{this.state.dataDetailStock?.[0]?.warehouse_name_destination}</Col>
                        </Row>
                        <br/>
                        <Table
                            rowKey={'stock_transfer_code'}
                            size={'small'}
                            loading={this.state.processingFetchDetailTableData}
                            columns={this.tableDetail}
                            dataSource={this.state.dataDetailStock}
                            pagination={false}
                        />
                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ListTransferStock), 5));
